<template>
  <div class="package-item">
    <div class="package d-flex align-items-center">
      <Select :options="packageOptions" :value="condition.package" @changeValue="store.commit(`${this.storeId}.package`, $event)" placeholder="Package" />
      <component :is="subConditionPackage" :config="subConditionConfig" @changeValue="changeSubConditionPackage" />
      <Select v-if="!hasChild" :options="conditionOptions" :value="condition.condition" @changeValue="handleChangeCondition" placeholder="Condition" />
      <component v-if="!hasChild" :is="subConditionValue" :config="config" />
      <span class="flex-1"></span>
      <i v-if="hasChild" @click="addItem" class="icon ti ti-square-rounded-plus"></i>
      <i @click="removeItem" class="icon remove ti ti-square-rounded-minus"></i>
    </div>
    <div v-if="hasChild" class="package-conditions">
      <ConditionItem v-for="(condition, key) in condition.conditions" :key="key" :config="{ store, condition, event, more, storeId: `${storeId}.conditions.${key}` }" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    more() {
      return this.config?.more || {}
    },
    packages() {
      return this.more?.receive_packages || {}
    },
    groups() {
      return this.more?.groups || {}
    },
    conditions() {
      return this.more?.conditions || {}
    },
    condition() {
      return this.config?.condition || {}
    },
    subConditionPackage() {
      let packageName
      if (Object.keys(this.packages).includes(this.condition.package)) {
        packageName = _.pascalCase(this.condition.package)
      } else if (Object.keys(this.groups).includes(this.condition.package)) {
        packageName = _.pascalCase(this.condition.package)
      }
      return packageName ? `ConditionPackage${packageName}` : null
    },
    subConditionValue() {
      let packageName = null
      if (this.packages?.[this.condition.package]?.value) {
        packageName = _.pascalCase(this.packages?.[this.condition.package]?.value)
      } else if (['empty', 'not_empty'].includes(this.condition.condition)) {
        packageName = null
      } else if (['!=', '<', '<=', '=', '>', '>='].includes(this.condition.condition)) {
        packageName = 'Default'
      } else if (Object.keys(this.conditions).includes(this.condition.condition)) {
        packageName = _.pascalCase(this.condition.condition)
      }
      return packageName ? `ConditionValue${packageName}` : null
    },
    subConditionConfig() {
      let config = _.cloneDeep(this.config)
      config.parentPackage = this.condition.package
      config.value = _.cloneDeep(this.condition)
      return config
    },
    packageOptions() {
      let packages = (this.more.events?.[this.event]?.packages || []).reduce((result, current) => {
        result.push({
          id: current,
          text: this.packages?.[current]?.label
        })
        return result
      }, [])
      Object.entries(this.groups).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value?.label
        })
        return result
      }, packages)
      return packages
    },
    conditionOptions() {
      let conditions = this.packages?.[this.condition.package]?.conditions || Object.keys(this.conditions)
      return conditions.reduce((result, current) => {
        result.push({
          id: current,
          text: this.conditions?.[current]
        })
        return result
      }, [])
    },
    hasChild() {
      return this.groups?.[this.condition?.package]?.has_child || false
    }
  },
  methods: {
    handleChangeCondition(e) {
      this.store.commit(`${this.storeId}.condition`, e)
    },
    changeSubConditionPackage({ field, value }) {
      this.store.commit(`${this.storeId}.${field}`, value)
    },
    addItem() {
      if (this.hasChild) {
        let conditions = this.store.getter(`${this.storeId}.conditions`, [])
        conditions.unshift({})
        this.store.commit(`${this.storeId}.conditions`, conditions)
      }
    },
    removeItem() {
      const lastIndex = this.storeId.lastIndexOf('.')
      const baseStoreId = this.storeId.substring(0, lastIndex)
      const index = this.storeId.substring(lastIndex + 1)
      let conditions = this.store.getter(baseStoreId, [])
      conditions.splice(index, 1)
      this.store.commit(baseStoreId, conditions)
    }
  },
  watch: {
    'condition.package'(name) {
      this.store.commit(this.storeId, {
        package: name
      })
    },
    'subConditionValue': {
      handler(name) {
        if (this.$options.components?.[name] || !name) return
        const path = `/views/Automation/Modal/Conditions/Values`
        this.$options.components[name] = this.$util.requireOrNull(`${path}/${name.replace(/^ConditionValue/g, '')}Value.vue`) || this.$util.requireOrNull(`${path}/DefaultValue.vue`)
      },
      immediate: true
    },
    'subConditionPackage': {
      handler(name) {
        if (this.$options.components?.[name] || !name) return
        const path = `/views/Automation/Modal/Conditions/Packages`
        this.$options.components[name] = this.$util.requireOrNull(`${path}/${name.replace(/^ConditionPackage/g, '')}Package.vue`) || this.$util.requireOrNull(`${path}/DefaultPackage.vue`)
      },
      immediate: true
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.edit-action-form {
  .package-conditions {
    padding-left: 20px;
  }
  .package-item {
    width: 100%;
    font-size: 14px;
    label {
      line-height: 1;
    }
    .multiselect {
      width: auto;
      min-width: 200px;
      border: 0 !important;
      border-radius: 20px;
      .multiselect-clear,
      .multiselect-caret {
        display: none;
      }
      .multiselect-multiple-label,
      .multiselect-placeholder,
      .multiselect-single-label,
      .multiselect-single-label-text,
      .multiselect-search {
        width: 100%;
        text-align: center;
        padding: 0;
        border-radius: 20px;
        font-size: inherit;
      }
      .multiselect-placeholder {
        justify-content: center;
      }
    }
    .input-value {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      border: 0;
      margin: 5px;
      font-size: inherit;
      text-align: center;
      &::placeholder {
        text-align: center;
      }
    }
    .package {
      border-radius: 20px;
      padding: 2px;
      margin-bottom: 10px;
      background: #efefef;
      > * {
        margin: 5px;
      }
    }
    .icon.remove {
      position: absolute;
      right: 20px;
    }
  }
}
</style>
